import { render, staticRenderFns } from "./HomepageNotifications.vue?vue&type=template&id=7541764b&scoped=true&"
import script from "./HomepageNotifications.vue?vue&type=script&lang=js&"
export * from "./HomepageNotifications.vue?vue&type=script&lang=js&"
import style0 from "./HomepageNotifications.vue?vue&type=style&index=0&id=7541764b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7541764b",
  null
  
)

export default component.exports